import { ContentPage } from '../page-factory/content-page';
import { mudhousePage } from '../pages/page-packages';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    {
      title: 'Sanskriti Vann Kutiram (Mud Houses) - Premium Accommodation - Kumbh Sukrit',
    },
    {
      name: 'description',
      content:
        'Experience authentic luxury in our Sanskriti Vann Kutiram (Mud Houses). Eco-friendly accommodations blending heritage architecture with modern comfort at Magh Mela 2026.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/accommodations/traditional-mudhouse',
    },
  ];
};

export default function MudhousePage() {
  return <ContentPage {...mudhousePage} />;
}
